<template>
  <div class="tab-form" id="category-list">
    <v-row>
      <strong class="mt-2 mr-2">カテゴリ名</strong>
      <v-text-field
        v-model="keyword"
        hide-details
        dense
        @keyup.enter="search"
        class="text-field-search mr-10"
        outlined
      />
      <v-btn color="primary" class="font-weight-black" @click="search">{{
        $t("SEARCH")
      }}</v-btn>

      <v-spacer />
      <v-select
        class="select-record"
        hide-details
        :items="recordsPage"
        v-model="pagination.maxResultCount"
        dense
        outlined
      />
      <CategoryAdd @resetList="handleResetList" :tabId="$route.params.tabId" />
    </v-row>
    <v-row>
      <v-layout child-flex class="pad-top-button">
        <v-data-iterator
          :items-per-page.sync="pagination.maxResultCount"
          :page="pagination.page"
          :items="listCategory"
          :loading="loading"
          hide-default-footer
        >
          <template v-slot:default="props">
            <v-row>
              <v-col
                v-for="(item, index) in props.items"
                :key="index"
                cols="2"
                class="card-list"
              >
                <v-card
                  color="#f5f5f5"
                  @click="
                    $router.push({
                      name: 'Detail Category',
                      params: {
                        categoryId: item.Id,
                        tabId: $route.params.tabId,
                      },
                    })
                  "
                >
                  <v-card-text class="align-start">
                    <div
                      class="font-weight-bold text-truncate"
                      style="max-width: 187px"
                    >
                      {{ item.name.ja }}
                    </div>
                    <div class="row pa-0 ma-0">
                      <div class="icon-trash">
                        <CategoryUpdate
                          :item="item"
                          @resetList="handleResetList"
                        />
                        <CategoryDelete
                          :item="item"
                          @resetList="handleResetList"
                        />
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </template>
          <template v-slot:no-data>
            <div class="text-center mt-5">データがありません。</div>
          </template>
          <template v-slot:loading>
            <div class="text-center mt-5">読み込み中。。。待ってください。</div>
          </template>
        </v-data-iterator>
      </v-layout>
    </v-row>
    <BasePagination
      v-if="listCategory.length > 0"
      :pageCount="listCategory.length"
      :pageSize="pagination.maxResultCount"
      @changePage="changePage"
    />
  </div>
</template>
<script>
import mixin from "@/mixin";
import BasePagination from "@/components/Pagination/BasePagination";
import CategoryAdd from "./CategoryAdd";
import CategoryUpdate from "./CategoryUpdate";
import CategoryDelete from "./CategoryDelete";
import { getListCategory } from "@/api/Category.api";
export default {
  mixins: [mixin.App],
  components: {
    BasePagination,
    CategoryAdd,
    CategoryUpdate,
    CategoryDelete,
  },
  data() {
    return {
      dialogUpdateCategory: false,
      loading: false,
      listCategory: [],
      defaultListCategory: [],
      keyword: "",
    };
  },
  async created() {
    await this.handleGetListCategory();
  },
  methods: {
    async handleGetListCategory() {
      let params = {
        keyword: "",
        tab: this.$route.params.tabId,
      };
      this.loading = true
      await getListCategory(params)
        .then((data) => {
          this.defaultListCategory = data.result;
          this.listCategory = data.result;
          this.pagination.pageCount = data.totalCount;
          this.loading = false
        })
        .catch((error) => this.$toast.error(error));
      this.loading = false
    },
    async search() {
      await this.handleGetListCategory();
      const { keyword } = this;
      let keywordSearch = keyword.toLowerCase();
      this.listCategory = this.defaultListCategory.filter(
        (item) =>
          item.name.ja.toString().toLowerCase().search(keywordSearch) > -1
      );
      this.pagination.pageCount = this.listCategory.length;
    },
    async handleResetList() {
      if (this.keyword !== "") return (this.keyword = "");
      await this.handleGetListCategory();
      this.$emit("resetList");
    },
    changePage(value) {
      this.pagination.page = value;
    },
  },
};
</script>
<style scoped>
</style>
